import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { RefreshCw, CheckCircle2 } from 'lucide-react';

const URL = `${process.env.REACT_APP_BACKEND_URL}/api/wartung`;

// Login-Seite: zeigt automatisch einen Hinweis, wenn der Server gerade nicht antwortet (Update) oder der Admin Wartung eingeschaltet hat
export const UpdateHinweis = () => {
  const [z, setZ] = useState({ art: '', text: '' });
  const war = useRef(false);
  useEffect(() => {
    let t;
    let aus = false;
    const pruefen = async () => {
      let art = '';
      let text = '';
      try {
        const r = await axios.get(URL, { timeout: 6000 });
        if (r.data?.aktiv) { art = 'wartung'; text = r.data.text; }
      } catch (e) {
        const st = e?.response?.status;
        if (!st || st >= 500) art = 'update';
      }
      if (aus) return;
      if (art) setZ({ art, text });
      else if (war.current) { setZ({ art: 'zurueck', text: '' }); setTimeout(() => !aus && setZ((s) => (s.art === 'zurueck' ? { art: '', text: '' } : s)), 6000); }
      else setZ((s) => (s.art === 'zurueck' ? s : { art: '', text: '' }));
      war.current = art === 'update';
      t = setTimeout(pruefen, art === 'update' ? 5000 : 30000);
    };
    pruefen();
    return () => { aus = true; clearTimeout(t); };
  }, []);
  if (!z.art) return null;
  if (z.art === 'zurueck') return (
    <div className="flex items-start gap-2 p-3 mb-5 bg-emerald-50 border-l-4 border-emerald-500 text-emerald-800 text-sm" data-testid="update-hinweis-zurueck">
      <CheckCircle2 className="w-4 h-4 flex-shrink-0 mt-0.5" /><span>Die Website ist wieder erreichbar – Sie können sich jetzt anmelden.</span>
    </div>
  );
  return (
    <div className="flex items-start gap-2 p-3 mb-5 bg-amber-50 border-l-4 border-amber-500 text-amber-900 text-sm" role="status" data-testid={`update-hinweis-${z.art}`}>
      <RefreshCw className={`w-4 h-4 flex-shrink-0 mt-0.5 ${z.art === 'update' ? 'animate-spin [animation-duration:2.5s]' : ''}`} />
      <span>{z.art === 'update' ? 'Die Website wird gerade aktualisiert. Die Anmeldung ist in wenigen Minuten wieder möglich – dieser Hinweis verschwindet automatisch.' : z.text}</span>
    </div>
  );
};

export default UpdateHinweis;
